import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./harnessIcon.html";
// Brand marks for each site install-method id (Figma Skills Marketplace 2645:69251). Agentforce Vibes
// has no image: it renders the SLDS agent_astro glyph on a tinted tile instead.
const HARNESS_IMAGE_SRC = {
  'claude-code': '/images/listing/harness-claude.png',
  codex: '/images/listing/harness-chatgpt.png',
  cursor: '/images/listing/harness-cursor.png',
  opencode: '/images/listing/harness-opencode.svg'
};
const AGENTFORCE_VIBES_ID = 'agentforce-vibes';

// Decorative 20px harness tile shown beside a harness name (Works With row, single-harness install
// heading). Renders nothing for an id without a mark, so callers can pass any harness id.
class HarnessIcon extends LightningElement {
  constructor(...args) {
    super(...args);
    this.installMethodId = '';
  }
  get imageSrc() {
    return HARNESS_IMAGE_SRC[this.installMethodId] ?? '';
  }
  get isAgentforceVibes() {
    return this.installMethodId === AGENTFORCE_VIBES_ID;
  }
  get hasIcon() {
    return !!this.imageSrc || this.isAgentforceVibes;
  }
  get tileClass() {
    return `harness-icon harness-icon--${this.installMethodId}`;
  }
  get imageClass() {
    return this.installMethodId === 'opencode' ? 'harness-icon__glyph-image' : 'harness-icon__image';
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(HarnessIcon, {
  publicProps: {
    installMethodId: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(HarnessIcon, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;